// Exporting the checkSubscription function
export const checkSubscription = (user) => {
  // Define an array of valid subscription plans
  const subscriptionPlans = ['calcium-monthly', 'calcium-quarterly', 'calcium-annually'];
  // Check if the user's plan is one of the subscription plans
  return subscriptionPlans.includes(user.userPlan);
}